module.exports = __webpack_public_path__ + "img/22-energy-vs.2b4f680e.png";